import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { HelloStep } from "@src/widgets/onboarding/classes/tours/WelcomeTour/steps/HelloStep"
import { SelectToursStep } from "@src/widgets/onboarding/classes/tours/WelcomeTour/steps/SelectToursStep"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export class WelcomeTour extends BaseTour {
  name = ONBOARDING_TOURS.WELCOME

  steps = [new HelloStep(), new SelectToursStep()]
}
